import { tw } from "@sveabank/cc-common";
import type { Images } from "../../images";
import Image from "../image";
import {
	type BulletVariant,
	bulletVariants,
	type ListItemVariants,
	listItemVariants,
} from "./constants";

type Props = {
	variant?: ListItemVariants;
	icon?: keyof typeof Images;
	bullet?: BulletVariant;
	children?: React.ReactNode;
};

const BulletListItem = ({ variant = "unstyled", bullet = "none", icon, children }: Props) => {
	const iconSize = variant === "small" ? tw`size-4` : tw`size-6`;

	return (
		<li className={tw(listItemVariants[variant], bulletVariants[bullet])}>
			{icon && <Image imageSrc={icon} altText="list item bullet" className={iconSize} />}
			{children}
		</li>
	);
};

export default BulletListItem;
